export default __webpack_public_path__ + "static/media/baby-32.efaa19a9.svg";